import { ReactNode } from "react";
import { DialogTitle } from "@/components/ui/dialog";

import { usePopupRegistration } from "@/hooks/usePopupRegistration";

interface DialogTitleWithBugProps {
  children: ReactNode;
  className?: string;
  popupName?: string;
  popupContext?: string;
  isOpen?: boolean;
  showBugIcon?: boolean;
}

export const DialogTitleWithBug = ({ 
  children, 
  className = "", 
  popupName,
  popupContext,
  isOpen = true,
  showBugIcon = true
}: DialogTitleWithBugProps) => {
  // Register popup if name and context are provided
  usePopupRegistration({
    name: popupName || "Dialog",
    context: popupContext || window.location.pathname,
    isOpen: isOpen && showBugIcon
  });

  return (
    <DialogTitle className={`flex items-center gap-2 ${className}`}>
      {/* Bug icon removed */}
      {children}
    </DialogTitle>
  );
};